<script>
import {getWeeklyReport} from '../api'

export default {
  data() {
    return {
      isDownloading: false // 控制按钮状态，防止重复点击
    };
  },
  methods: {
    // 处理下载逻辑
    async handleDownloadReports() {
      this.isDownloading = true;
      try {
        // 调用下载接口（注意需要指定responseType为blob，否则无法处理文件流）
        const response = await getWeeklyReport()

        // 处理返回的blob数据，创建下载链接
        const blob = new Blob([response.data], {
          type: 'application/zip' // 匹配后端返回的zip类型
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');

        // 获取文件名（优先从响应头获取，没有则用默认名）
        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'weekly_reports.zip';
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="(.+)"/);
          if (match && match[1]) {
            fileName = match[1];
          }
        }

        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        // 清理资源
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

      } catch (error) {
        console.error('下载失败:', error);
        // 可根据实际需求添加错误提示（如Element UI的Message）
        this.$message.error('下载失败，请稍后重试');
      } finally {
        this.isDownloading = false;
      }
    }
  }
};
</script>
<template>
  <!-- 下载按钮 -->
  <button
      @click="handleDownloadReports"
      class="download-btn"
      :disabled="isDownloading"
  >
    <span v-if="!isDownloading">下载最新周报</span>
    <span v-if="isDownloading">下载中...</span>
  </button>
</template>

<style scoped>
.download-btn {
  padding: 8px 16px;
  background: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.download-btn:disabled {
  background: #cccccc;
  cursor: not-allowed;
}
</style>
